import React from "react";

import PromoBlock from "@/components/common/promoBlock";
import ScrollToTopButton from "@/components/common/scrollToTopButton";
import { ShowcaseHeadingLevelContext } from "@/components/common/showcaseBlock/headingLevelContext";
import { useBanners } from "@/hooks/useBanners";
import useTextContents from "@/hooks/useTextContents";
import { cleanupFromDangerousTags } from "@/utils/stringUtils";
import Breadcrumbs from "@components/common/Breadcrumbs";
import { BreadcrumbUrlPrefixEnum } from "@components/common/Breadcrumbs/types";
import SeoHeaders from "@components/common/seoHeaders";

import Constructor from "../constructor";
import { getFirstScreenZone } from "../constructor/utils";
import LinkBlock from "../linkBlock";
import { LinkUrlPrefixEnum } from "../types";
import { getHubItemList, getLinkBlockObject } from "../utils";

import { GoroskopProps } from "./types";

import "../styles.scss";
import "./styles.scss";

const Goroskop = ({ pageContext }: GoroskopProps) => {
  const {
    seoId,
    title = "Гороскоп на Lunaro",
    ogTitle,
    description = "Гороскоп на Lunaro",
    textTop,
    textMiddle,
    textBottom,
    header,
    breadcrumbDisplayName,
    breadcrumbs,
    goroskopLinks,
    autolinkedGoroskopLinks,
    url,
    expertsInitial,
    zone,
    commonTextTopBottomZone,
    commonTextMiddleBottomZone,
    commonBottomZone,
    wideBannerData,
    isContentsHidden,
  } = pageContext;
  const { checkIsWideBannerActive } = useBanners();
  const {
    HeadingsLayout,
    convertedTextBottom,
    convertedTextMiddle,
    convertedTextTop } = useTextContents({ textTop, textMiddle, textBottom, isContentsHidden });
  // картинку первого экрана получает только зона, выше которой нет длинного текста и других блоков
  const firstScreenZone = getFirstScreenZone([
    textTop,
    commonTextTopBottomZone,
    textMiddle,
    commonTextMiddleBottomZone,
    !!goroskopLinks?.length,
    textBottom,
    zone,
  ]);

  // const fieldItems = [...emailItems, ...birthdateItems];

  const wideBannerBannerIsShown = wideBannerData && checkIsWideBannerActive({
    isShown: wideBannerData.wideBannerIsShownOnGoroskop,
    isShownForUnauthorized: wideBannerData.wideBannerIsShownForUnauthorized,
    isShownForAuthorizedWithTrial: wideBannerData.wideBannerIsShownForAuthorizedWithTrial,
    isShownForAuthorizedWithoutTrial: wideBannerData.wideBannerIsShownForAuthorizedWithoutTrial,
  });

  return (
    <ShowcaseHeadingLevelContext.Provider value="h2">
      <SeoHeaders
        title={title}
        ogTitle={ogTitle}
        description={description}
        url={url}
        imageUrl={`${textTop}${textMiddle}${textBottom}`?.match(/src\s*=\s*"(.+?)"/)?.[1]}
        itemList={getHubItemList(url, zone)}
      />
      {wideBannerBannerIsShown && <PromoBlock wideBannerData={wideBannerData} />}
      <ScrollToTopButton />
      <div
        className="bg--white goroskop"
      >
        <div className="page-width">
          <Breadcrumbs
            seoId={seoId}
            url={url}
            breadcrumbDisplayName={breadcrumbDisplayName}
            breadcrumbs={breadcrumbs}
            urlPrefix={BreadcrumbUrlPrefixEnum.Goroskop}
          />
          <h1 className="goroskop__headline">
            {header || ""}
          </h1>
          <HeadingsLayout />
          <>
            {!!textTop && (
              <div
                className="seo-typography"
                dangerouslySetInnerHTML={{
                  __html: cleanupFromDangerousTags(convertedTextTop || ""),
                }}
              />
            )}
            <Constructor
              zone={commonTextTopBottomZone}
              expertsInitial={expertsInitial}
              isImagePriorityAllowed={commonTextTopBottomZone === firstScreenZone}
            />
            {!!textMiddle && (
              <div
                className="seo-typography"
                dangerouslySetInnerHTML={{
                  __html: cleanupFromDangerousTags(convertedTextMiddle || ""),
                }}
              />
            )}
            <Constructor
              zone={commonTextMiddleBottomZone}
              expertsInitial={expertsInitial}
              isImagePriorityAllowed={commonTextMiddleBottomZone === firstScreenZone}
            />
            {!!goroskopLinks?.length && (
              <LinkBlock links={getLinkBlockObject(goroskopLinks, LinkUrlPrefixEnum.Goroskop)} />
            )}
            {!!textBottom && (
              <div
                className="seo-typography"
                dangerouslySetInnerHTML={{
                  __html: cleanupFromDangerousTags(convertedTextBottom || ""),
                }}
              />
            )}
          </>

          <Constructor
            zone={zone}
            expertsInitial={expertsInitial}
            isImagePriorityAllowed={zone === firstScreenZone}
          />
          <Constructor zone={commonBottomZone} expertsInitial={expertsInitial} isImagePriorityAllowed={false} />
        </div>
      </div>
    </ShowcaseHeadingLevelContext.Provider>
  );
};

export default Goroskop;
